import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import BottomNav from "@/components/BottomNav";
import Login from "@/pages/Login";
import Heute from "@/pages/Heute";
import Zeiten from "@/pages/Zeiten";
import Bautagebuch from "@/pages/Bautagebuch";
import Projekt from "@/pages/Projekt";
import ProjektDetail from "@/pages/ProjektDetail";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function AppShell({ children }) {
    return (
        <div className="min-h-screen bg-surface-app text-slate-900">
            {children}
            <BottomNav />
        </div>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/heute" element={<ProtectedRoute><AppShell><Heute /></AppShell></ProtectedRoute>} />
                    <Route path="/zeiten" element={<ProtectedRoute><AppShell><Zeiten /></AppShell></ProtectedRoute>} />
                    <Route path="/bautagebuch" element={<ProtectedRoute><AppShell><Bautagebuch /></AppShell></ProtectedRoute>} />
                    <Route path="/projekt" element={<ProtectedRoute><AppShell><Projekt /></AppShell></ProtectedRoute>} />
                    <Route path="/projekt/:id" element={<ProtectedRoute><AppShell><ProjektDetail /></AppShell></ProtectedRoute>} />
                    <Route path="/admin" element={<ProtectedRoute adminOnly><AppShell><Admin /></AppShell></ProtectedRoute>} />
                    <Route path="/" element={<Navigate to="/heute" replace />} />
                    <Route path="*" element={<Navigate to="/heute" replace />} />
                </Routes>
                <Toaster position="top-right" />
            </AuthProvider>
        </BrowserRouter>
    );
}
